import script from "./IiccMain.vue?vue&type=script&setup=true&lang=js"
export * from "./IiccMain.vue?vue&type=script&setup=true&lang=js"

import "./IiccMain.vue?vue&type=style&index=0&id=856d41f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-856d41f2"]])

export default __exports__